// Injected by the build/deployment environment so the UI identifies its artifact.
export const APP_VERSION = process.env.REACT_APP_VERSION?.trim() || "2026.10.13-local";

export default APP_VERSION;
